export const SET_APP_SELECTED_RESTAURANT = '@restaurant/SET_APP_SELECTED_RESTAURANT';
export const SET_APP_SELECTED_MENU = '@menu/SET_APP_SELECTED_MENU';
export const SET_APP_SELECTED_CATEGORY = '@category/SET_APP_SELECTED_CATEGORY';
export const SET_APP_SELECTED_DISH = '@dish/SET_APP_SELECTED_DISH';
